export default [
  {
    key: 'filminfo',
    name: 'Film Information',
    fields: [
      ['film_id', 'Film ID'],
      ['film_type', 'Film Type'],
      ['film_roll_cost', 'Film Roll Cost', { unit: '$', prefix: true }],
      ['film_roll_len', 'Film Roll Length', { unit: 'feet' }],
      ['film_width', 'Film Width', { unit: 'inches' }],
      ['film_thick', 'Film Thickness', { unit: 'gauge' }],
      ['core_radius', 'Core Radius', { unit: 'inches' }]
    ]
  },
  {
    key: 'loadrecipe',
    name: 'Load Recipes',
    fields: [
      ['recipe_num', 'Recipe Number'],
      ['recipe_desc', 'Recipe Description'],
      ['load_dimension', 'Load Dimension', { hideTable: true, pseudo: true, unit: 'inches' }],
      ['load_len', 'Load Length', { hideEditor: true, unit: 'inches' }],
      ['load_width', 'Load Width', { hideEditor: true, unit: 'inches' }],
      ['load_perim', 'Load Perimeter', { hideEditor: true, unit: 'inches' }],
      ['load_complete_seconds', 'Load Complete Seconds'],
      ['rev_limit_high', 'Revolutions Limit High'],
      ['rev_limit_low', 'Revolutions Limit Low'],
      ['rev_target', 'Revolutions Target'],
      ['stretch_limit_high', 'Stretch % Limit High'],
      ['stretch_limit_low', 'Stretch % Limit Low'],
      ['stretch_target', 'Stretch % Limit Target'],
      ['unw_len_lim_high', 'Unwind Length High', { unit: 'feet' }],
      ['unw_len_lim_low', 'Unwind Length Low', { unit: 'feet' }],
      ['unw_len_targ', 'Unwind Length Target', { unit: 'feet' }],
      ['ratio_stan_trigger_warning', 'Ratio Stan Trigger Warning']
    ]
  }
]
